import { render, staticRenderFns } from "./RootHeader.vue?vue&type=template&id=dd5ce784&scoped=true&"
import script from "./RootHeader.vue?vue&type=script&lang=js&"
export * from "./RootHeader.vue?vue&type=script&lang=js&"
import style0 from "./RootHeader.vue?vue&type=style&index=0&id=dd5ce784&prod&lang=scss&"
import style1 from "./RootHeader.vue?vue&type=style&index=1&id=dd5ce784&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd5ce784",
  null
  
)

export default component.exports